import googlePreferredIcon from "@assets/icons/googlePreferredSource.png";
import { GOOGLE_PREFERED_SOURCES_LINK } from "@config/Constants";
import LinkIcon from "@elements/Icon/LinkIcon";
import { WEB2_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { useTablaCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTablaCustomEventAnalyticsCall";

export type googlePreferedButtonProps = {
  className?: string;
  pageUrl: string;
};
/**
 * A React component that renders a Google Preferred Source Button on Article page
 */
export default function GooglePreferedSourceButton({
  className,
  pageUrl,
}: googlePreferedButtonProps): React.ReactElement {
  const TablaCustomGaEvent = useTablaCustomEventAnalyticsCall();

  const handleOnClick = () => {
    TablaCustomGaEvent({
      event: "customEvent",
      clickCategory: "preferred source on google",
      clickAction: "click",
      clickLabel: `${removeTrailingSlash(WEB2_BASE_URL)}${pageUrl}`,
    });
  };

  return (
    <div className={className}>
      <LinkIcon
        destination={GOOGLE_PREFERED_SOURCES_LINK}
        onClick={() => {
          handleOnClick();
        }}
        src={googlePreferredIcon}
        alt="google-preferred-source"
        height="39px"
        width="139px"
      />
    </div>
  );
}
